import React, { useState } from 'react';
import { Box, Grid, Typography, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import MessagesInteraction from './MessagesInteraction';
import HeatmapChart from './HeatmapChart';
import DonutChart from './DonutChart';
import GroupedBarChart from './GroupedBarChart';
import ServiceTimeChart from './ServiceTimeChart';
import SlotUtilizationChart from './SlotUtilizationChart';
import UniqueUsersChart from './UniqueUsersChart';
import NewUsersChart from './NewUsersChart';
import ReturningUsersChart from './ReturningUsersChart';
import SatisfactionChart from './SatisfactionChart';
import CustomLoader from "../../components/CustomLoader";

const dashboardOptions = [
    { value: 'sms-interactions', label: 'SMS Interactions' },
    { value: 'satisfaction-score', label: 'Satisfaction Score' },
    { value: 'login-activity', label: 'Login Activity' },
    { value: 'survey-completion', label: 'Survey Completion' },
    { value: 'visit-status', label: 'Visit Status' },
    { value: 'service-time', label: 'Service Time' },
    { value: 'slot-utilization', label: 'Slot Utilization' },
    { value: 'unique-users', label: 'Unique Users' },
    { value: 'new-users', label: 'New Users by Method' },
    { value: 'returning-users', label: 'New vs Returning Users' }
];

export default function ChartSelector(props) {
    const { loginUser } = props;
    const [selectedChart, setSelectedChart] = useState('sms-interactions');
    const [loading, setLoading] = useState(false);

    const handleChartChange = (event) => {
        setLoading(true);
        // Short timeout to show loading state for better UX
        setTimeout(() => {
            setSelectedChart(event.target.value);
            setLoading(false);
        }, 300);
    };

    // Render the selected chart component
    const renderChart = () => {
        switch (selectedChart) {
            case 'sms-interactions':
                return <MessagesInteraction loginUser={loginUser} />;
            case 'satisfaction-score':
                return <SatisfactionChart loginUser={loginUser} />;
            case 'login-activity':
                return <HeatmapChart loginUser={loginUser} />;
            case 'survey-completion':
                return <DonutChart loginUser={loginUser} />;
            case 'visit-status':
                return <GroupedBarChart loginUser={loginUser} />;
            case 'service-time':
                return <ServiceTimeChart loginUser={loginUser} />;
            case 'slot-utilization':
                return <SlotUtilizationChart loginUser={loginUser} />;
            case 'unique-users':
                return <UniqueUsersChart loginUser={loginUser} />;
            case 'new-users':
                return <NewUsersChart loginUser={loginUser} />;
            case 'returning-users':
                return <ReturningUsersChart loginUser={loginUser} />;
            default:
                return <Typography>Please select a dashboard</Typography>;
        }
    };

    return (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%", height: "100%" }}>
            <Box sx={{ 
                display: "flex", 
                flexDirection: "column",
                justifyContent: "flex-start", 
                alignItems: "center", 
                width: "95%", 
                height: "90%", 
                textAlign: "center", 
                marginTop: { xs: "4.5rem", sm: "2rem", md: "0" } 
            }}>
                <Grid container direction="row" spacing={2} sx={{display: "flex", justifyContent: "center"}}>
                    <Grid item xs={12}>
                        <Typography variant="h3" sx={{ marginTop: "5rem", fontWeight: "bold", color: "#01929b" }}>
                            Data Analytics Dashboard
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} lg={4} sx={{ marginBottom: 4 }}>
                        <FormControl fullWidth>
                            <InputLabel id="chart-selector-label">Select a Dashboard</InputLabel>
                            <Select
                                labelId="chart-selector-label"
                                id="chart-selector"
                                value={selectedChart}
                                label="Select a Dashboard"
                                onChange={handleChartChange}
                                sx={{ 
                                    backgroundColor: "#fff",
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#01929b',
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#01929b',
                                    },
                                }}
                            >
                                {dashboardOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        {loading ? <CustomLoader /> : renderChart()}
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
} 